<template>
<div>
  <el-row type="flex" class="title-bar" :style="'justify-content:' + (operationFlag ? 'flex-end;' : 'space-between;')">
    <w-perf-analysis-time-info v-if="!operationFlag" :ref="timeInfoRef" :check-datetime="checkDatetime" @change="onTimeTypeChange" @reload="onCurrentDataReLoad"/>
    <span>
      <el-radio-group class="mr-r10" v-model="searchLogType" @change="onChangeSearchType">
        <el-radio label="origin">원본 로그</el-radio>
        <el-radio label="filtering">필터링 로그</el-radio>
      </el-radio-group>
      <el-select v-model="searchTypeCheck" v-show="searchLogType === 'filtering'" :disabled="searchLogType === 'origin'" @change="onChangeSearchType">
        <el-option label="전체" value="total"></el-option>
        <el-option label="확인" value="checked"></el-option>
        <el-option label="미확인" value="unchecked"></el-option>
      </el-select>
      <!-- <el-select style="width:160px" v-model="searchFilterId" placeholder="정책을 선택해주세요." clearable v-show="searchLogType === 'filtering'" :disabled="searchLogType === 'origin'" @change="onChangeSearchType">
        <el-option v-for="item in trapRuleList" :key="item.syslogRuleId" :value="item.syslogRuleId" :label="item.syslogRuleName" />
      </el-select> -->
      <el-button size="small" class="mr-r4" @click="changeIsChecked" :disabled="disableCheck" v-show="isLms">확인</el-button>
      <w-header-search-button @click="onShowSearchToolButtonClick"></w-header-search-button>
    </span>
  </el-row>
  <el-table-wrapper v-loading="loading" ref="trapTable" :data="tableData" :total="total" :columns="columns" :show-custom-header="true" :show-search-tool="showSearchTool" remote
  @selection-change="onSelectionChange" :pagination="true" :column-default="columnDefault" @condition-change="loadData">
    <template slot-scope="scope" slot="is-checked-slot">
      <span v-if="scope.row.isChecked === '1'">확인</span>
      <span v-else-if="scope.row.isChecked === '0'">미확인</span>
      <span v-else>-</span>
    </template>
  </el-table-wrapper>
</div>
</template>
<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import { isEqual, isNil, forEach, findIndex, isEmpty } from 'lodash';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { getDateToString, getIntervalDatetimeParams } from '@/utils/date';
import msgUtil from '@/utils/message';
import { columnDefault } from '@/constants/table';
import { analysisTimeType } from '@/constants/performance';
import logAPI from '@/api/log/common';
// import trapSettingAPI from '@/api/settings/log/snmptrap-settings';
import analysisTableMixin from '@/mixins/performance/analysis-table-ex';
import WPerfAnalysisTimeInfo from '@/views/performance/node/analysis/components/PerfAnalysisTimeInfo';

export default {
  name: 'WSnmpTrapTable',
  mixins: [analysisTableMixin],
  components: {
    WPerfAnalysisTimeInfo,
  },
  data() {
    return {
      searchLogType: 'origin',
      searchTypeCheck: 'total',
      searchFilterId: null,
      trapRuleList: null,
      loading: false,
      columnDefault,
      headerSearchKeyword: {},
      tableData: [],
      showSearchTool: false,
      checkDatetime: null,
      total: 0,
      limit: 50,
      start: 0,
      disableCheck: true,
    };
  },
  computed: {
    ...mapGetters(['activeManagetypeIds', 'selectedNode']),
    isLms() {
      return findIndex(this.activeManagetypeIds, (item) => item === 'LMS') >= 0;
    },
    objId() {
      if (isNil(this.selectedNode)) {
        return null;
      }
      if (isNil(this.selectedNode.obj)) {
        return null;
      }
      return this.selectedNode.obj.objId;
    },
    columns() {
      const idx = findIndex(this.activeManagetypeIds, (item) => item === 'LMS');
      if (idx === -1) {
        return [{
          prop: 'severity',
          label: 'severity',
          showOverflowTooltip: true,
          width: 100,
          searchable: true,
          sortable: true,
          formatter: this.getStringFormatter,
        }, {
          prop: 'filterName',
          label: '필터',
          width: 150,
          showOverflowTooltip: true,
          searchable: true,
          sortable: true,
          formatter: this.getStringFormatter,
        }, {
          prop: 'message',
          label: '메시지',
          showOverflowTooltip: true,
          searchable: true,
          sortable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        }, {
          prop: '@timestamp',
          label: '수집시각',
          showOverflowTooltip: true,
          formatter: this.getDateFormatter,
          width: 200,
          sortable: true,
        }];
      }

      return [{
        type: 'selection',
        width: '50',
      }, {
        prop: 'isChecked',
        label: '상태',
        width: 60,
        scopedSlot: 'is-checked-slot',
      }, {
        prop: 'sourceName',
        label: '로그 소스',
        width: 150,
        searchable: true,
        sortable: true,
        formatter: this.getStringFormatter,
      }, {
        prop: 'originMessage',
        label: '원본 메시지',
        searchable: true,
        sortable: true,
        formatter: this.getStringFormatter,
      }, {
        prop: 'filterName',
        label: '정책 이름',
        width: 150,
        searchable: true,
        sortable: true,
        formatter: this.getStringFormatter,
      }, {
        prop: 'timestamp',
        label: '수집 시간',
        width: 160,
        searchable: true,
        searchType: 'date',
        sortable: true,
        formatter: this.getDateFormatter,
      }];
    },
  },
  watch: {
    // 다른 대상을 선택할 시에 필터링됐던 syslogRuleId를 해제
    selectedNode: {
      handler(to, from) {
        if (!isEqual(to.treeKey, from.treeKey) && !isNil(from)) {
          this.$nextTick(() => {
            this.$refs.trapTable.setCurrentPage(1);
          });
        }
      },
    },
  },
  methods: {
    /**
     * 데이터를 조회한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadData() {
      // if (isNil(this.trapRuleList)) {
      //   if (!this.active) {
      //     return;
      //   }
      //   const params = {
      //     params: {
      //       objId: this.objId,
      //     },
      //   };
      //   trapSettingAPI.getSyslogRuleByObj(params).then((response) => {
      //     const result = response.data;
      //     if (result.success) {
      //       const resultData = result.data;
      //       this.trapRuleList = resultData;
      //       const syslogTable = this.$refs.syslogTable;
      //       if (!isNil(syslogTable)) {
      //         this.loadLogData();
      //       } else {
      //         this.$nextTick(() => { // mount 전 호출될 경우 reference 참조가 안되므로 이 경우는 DOM 업데이트 완료 후 데이터를 로드하도록 함.
      //           this.loadLogData();
      //         });
      //       }
      //     } else {
      //       this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '시스로그 룰', false));
      //     }
      //   }).catch(() => {
      //     this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '시스로그 룰', false));
      //   });
      // } else {
      const trapTable = this.$refs.trapTable;
      if (!isNil(trapTable)) {
        this.loadLogData();
      } else {
        this.$nextTick(() => { // mount 전 호출될 경우 reference 참조가 안되므로 이 경우는 DOM 업데이트 완료 후 데이터를 로드하도록 함.
          this.loadLogData();
        });
      }
    },
    /**
     * 로그 데이터를 조회한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadLogData() {
      let baseDatetime;
      if (this.timeType === analysisTimeType.HIST.value && !this.operationFlag) {
        baseDatetime = this.plotLineDatetime;
        this.checkDatetime = Number.isInteger(this.plotLineDatetime) ? this.plotLineDatetime : this.plotLineDatetime.getTime();
      } else {
        baseDatetime = new Date();
      }
      const dateParams = this.getDatetimeParams(baseDatetime, true);
      const tableSearchParams = this.$refs.trapTable.getParameter();

      const params = {
        objId: this.selectedNode.obj.objId,
        logType: 'TRAP',
        type: 'performance',
        startDateTime: dateParams.startDatetime,
        endDateTime: dateParams.endDatetime,
        start: tableSearchParams.start,
        limit: tableSearchParams.limit,
      };

      const queryList = [];
      if (!isNil(tableSearchParams.searchParams)) {
        forEach(tableSearchParams.searchParams, (item) => {
          if (item.field === 'isChecked') {
            queryList.push({ field: item.field, value: item.value === '확인' ? '1' : '0', operator: 'AND' });
          } else {
            queryList.push({ field: item.field, value: item.value, operator: 'AND' });
          }
        });
      }
      const idx = findIndex(this.activeManagetypeIds, (item) => item === 'LMS');

      // 1. 원본/필터링 로그 조회 타입 추가 (라디오)
      if (this.searchLogType === 'filtering') {
        // 필터링 로그
        queryList.push({ field: 'filterId', operator: 'EXIST' });
        // 2. 확인/미확인 조회 타입 추가 (콤보박스)
        if (this.searchTypeCheck === 'checked') {
          // 확인만
          queryList.push({ field: 'isChecked', value: '1', operator: 'AND' });
        } else if (this.searchTypeCheck === 'unchecked') {
          // 미확인만
          queryList.push({ field: 'isChecked', value: '0', operator: 'AND' });
        }
        // filterId
        // if (!isNil(this.searchFilterId) || this.searchFilterId === '') {
        //   const syslogRule = this.trapRuleList.find((item) => item.syslogRuleId === this.searchFilterId);
        //   const syslogRuleName = !isNil(syslogRule) ? syslogRule.syslogRuleName : null;
        //   queryList.push({ field: 'filterId', value: syslogRuleName, operator: 'AND' });
        // }
      }
      if (idx !== -1) {
        queryList.push({ field: 'objId', value: this.selectedNode.obj.objId, operator: 'AND', regex: 'N' });
        queryList.push({ field: 'logType', value: 'TRAP', operator: 'AND', regex: 'N' });
      }

      params.queryList = queryList;

      this.loading = true;
      logAPI.getLogAnalysisData(params).then((response) => {
        if (response.data.success) {
          this.tableData = response.data.data;
          this.total = response.data.total;
        } else {
          this.failToLoad();
        }
      }).catch(() => {
        this.failToLoad();
      }).finally(() => {
        this.loading = false;
      });
    },
    // loadSyslogRuleData() {
    //   if (!this.active) {
    //     return;
    //   }
    //   trapSettingAPI.getSnmptrapSetDetail().then((response) => {
    //     const result = response.data;
    //     if (result.success) {
    //       const resultData = result.data;
    //       this.trapRuleList = resultData;
    //     } else {
    //       this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '시스로그 룰', false));
    //     }
    //   }).catch(() => {
    //     this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '시스로그 룰', false));
    //   });
    // },
    /**
     * 데이터 로드 실패 처리
     * @author Ju
     * @return {[type]} [description]
     */
    failToLoad() {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, 'SNMP 트랩', false));
    },
    /**
     * [검색기능 show]
     * @author {Yang}
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    onShowSearchToolButtonClick() {
      this.showSearchTool = !this.showSearchTool;
    },
    /**
     * 로그 상태 변경 (확인/ 미확인)
     * @author leesy918
     * @param  {[type]} event [description]
     * @return {[type]}       [description]
     */
    changeIsChecked(event) {
      event.stopPropagation();
      const checkedRow = [];
      this.$confirm(...msgUtil.getBasicConfirmData(msgUtil.action.CHECK)).then(() => {
        this.loading = true;
        this.checkedRow.forEach((item) => {
          if (item.isChecked === '0') {
            checkedRow.push(item);
          }
        });
        if (isEmpty(checkedRow)) {
          this.$message(msgUtil.getCustomMsgData('변경사항이 없습니다.'));
          this.$refs.logTable.$children[0].clearSelection();
          return;
        }
        const params = checkedRow;
        logAPI.updateLogIsChecked(params).then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.CHECK, '로그', response.data.success));
            this.loadData();
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.CHECK, '로그', response.data.success));
            this.loading = false;
          }
        });
      }).catch(() => {});
    },
    /**
     * [날짜 포멧 설정]
     * @author {Yang}
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    getDateFormatter(row, column, value) {
      if (this.isLms) {
        if (!isNil(value)) {
          return getDateToString(getIntervalDatetimeParams(value, 'hour', 9), 'YYYY-MM-DD HH:mm:ss');
        }
      } else {
        return isNil(value) ? EMPTY_TEXT : moment(new Date(value)).format('YYYY-MM-DD HH:mm:ss');
      }
      return EMPTY_TEXT;
    },
    filterSyslogPriorityName(value, row) {
      return row.syslogPriorityName === value;
    },
    getStringFormatter(row, column, value) {
      return isNil(value) ? EMPTY_TEXT : value;
    },
    /**
     * 테이블 데이터 빈값 확인
     * @author Yang
     * @param  {Object} row
     * @param  {Object} column
     * @param  {String/Number} valu
     */
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    onSelectionChange(data) {
      this.disableCheck = isEmpty(data);
      this.checkedRow = data;
    },
    onCurrentPageChange(page) {
      this.limit = page.pageSize;
      this.start = (page.currentPage - 1) * this.limit;
      this.loadLogData();
    },
    onChangeSearchType() {
      this.$refs.trapTable.setCurrentPage(1);
    },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/netdevice/components/table/SnmpTrapTable.vue